import InfoModal from '@/components/InfoModal';

import useStore from '@/hooks/useStore';

type HeadLineDescriptionProps = { description: string };

const HeadLineDescription = ({ description }: HeadLineDescriptionProps) => {
  const { UIStore } = useStore();
  const { setIsShowInfoModal } = UIStore;

  const onClickGuidButton = () => {
    setIsShowInfoModal(true);
  };

  return (
    <>
      <p className="c-p-headline__desc">
        {description}{' '}
        <button
          type="button"
          className="c-iconinfo c-iconinfo--info"
          aria-expanded="false"
          aria-controls="arModal1"
          onClick={onClickGuidButton}
        >
          급상승 인기 키워드 도움말
        </button>
      </p>
      <InfoModal />
    </>
  );
};

export default HeadLineDescription;
